module.exports = __webpack_public_path__ + "img/photo-21.6006e858.webp";